import { ws } from "../../../utils/common";

export const getDetailsEventWS = async ({ id }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "event/" + id,
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};

export const viewEventPageWS = async ({ id }) => {
  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "traffic-event/" + id,
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};
